import {
  TSteelGradeGroup,
} from './select-alloying-elements';

const steelGradeGroup: Record<TSteelGradeGroup, string> = {
  caseHardeningSteel: 'Stal do nawęglania',
  nitridingSteel: 'Stal do azotowania',
  temperingSteel: 'Stal do hartowania',
  bearingSteel: 'Stal łożyskowa',
};

export default {
  placeholder: 'Wybierz grupę gatunków stali',
  steelGradeGroup,
};
